import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateRejectionReason from "./customerRefundCandidateRejectionReason";
import CustomerRefundCandidatePreviewDetailResponse from "./customerRefundCandidatePreviewDetailResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePreviewResponse {
  /**
   * If true - candidate can be submitted.
   */
  @observable
  canBeSubmitted!: boolean;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  @observable
  rejectionReason?: CustomerRefundCandidateRejectionReason;

  @observable
  @Type(() => CustomerRefundCandidatePreviewDetailResponse)
  candidatePreview!: CustomerRefundCandidatePreviewDetailResponse;
}
